/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoadingRouteImport } from './routes/loading'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as PrivateRouteImport } from './routes/_private'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PrivateUsdaImageCalibrationRouteImport } from './routes/_private/usda-image-calibration'
import { Route as PrivateUsdaAuditFeedbackRouteImport } from './routes/_private/usda-audit-feedback'
import { Route as PrivateUsdaAuditRouteImport } from './routes/_private/usda-audit'
import { Route as PrivateNoPackagesRouteImport } from './routes/_private/no-packages'
import { Route as PrivateMeqLiveGeneticsRouteImport } from './routes/_private/meq-live-genetics'
import { Route as PrivateMeqLiveAdminRouteImport } from './routes/_private/meq-live-admin'
import { Route as PrivateMeqLiveRouteImport } from './routes/_private/meq-live'
import { Route as PrivateMainRouteImport } from './routes/_private/main'
import { Route as PrivateGmpUploadRouteImport } from './routes/_private/gmp-upload'
import { Route as PrivateAdministrationRouteImport } from './routes/_private/administration'
import { Route as PrivateUsdaAuditIndexRouteImport } from './routes/_private/usda-audit/index'
import { Route as PrivateUsdaAuditFeedbackIndexRouteImport } from './routes/_private/usda-audit-feedback/index'
import { Route as PrivateRecordLabellingAdminIndexRouteImport } from './routes/_private/record-labelling-admin/index'
import { Route as PrivateMeqProbeIndexRouteImport } from './routes/_private/meq-probe/index'
import { Route as PrivateMeqLiveIndexRouteImport } from './routes/_private/meq-live/index'
import { Route as PrivateMeqLiveGeneticsIndexRouteImport } from './routes/_private/meq-live-genetics/index'
import { Route as PrivateMeqLiveAdminIndexRouteImport } from './routes/_private/meq-live-admin/index'
import { Route as PrivateMeqCameraIndexRouteImport } from './routes/_private/meq-camera/index'
import { Route as PrivateManagementIndexRouteImport } from './routes/_private/management/index'
import { Route as PrivateGmpLambDataAnalysisIndexRouteImport } from './routes/_private/gmp-lamb-data-analysis/index'
import { Route as PrivateGmpLambBookingsIndexRouteImport } from './routes/_private/gmp-lamb-bookings/index'
import { Route as PrivateDataAnalysisOverviewIndexRouteImport } from './routes/_private/data-analysis-overview/index'
import { Route as PrivateAdministrationIndexRouteImport } from './routes/_private/administration/index'
import { Route as PrivateUsdaAuditResultsRouteImport } from './routes/_private/usda-audit/results'
import { Route as PrivateUsdaAuditAuditRouteImport } from './routes/_private/usda-audit/audit'
import { Route as PrivateUsdaAuditSplatRouteImport } from './routes/_private/usda-audit/$'
import { Route as PrivateUsdaAuditFeedbackAuditRouteImport } from './routes/_private/usda-audit-feedback/audit'
import { Route as PrivateUsdaAuditFeedbackSplatRouteImport } from './routes/_private/usda-audit-feedback/$'
import { Route as PrivateRecordLabellingMyAssignmentsRouteImport } from './routes/_private/record-labelling.my-assignments'
import { Route as PrivateRecordLabellingAdminSetupRouteImport } from './routes/_private/record-labelling-admin/setup'
import { Route as PrivateRecordLabellingAdminSplatRouteImport } from './routes/_private/record-labelling-admin/$'
import { Route as PrivateMeqProbeSplatRouteImport } from './routes/_private/meq-probe/$'
import { Route as PrivateMeqLiveSummaryOfScansRouteImport } from './routes/_private/meq-live/summary-of-scans'
import { Route as PrivateMeqLiveSplatRouteImport } from './routes/_private/meq-live/$'
import { Route as PrivateMeqLiveGeneticsSireAnalysisRouteImport } from './routes/_private/meq-live-genetics/sire-analysis'
import { Route as PrivateMeqLiveGeneticsSplatRouteImport } from './routes/_private/meq-live-genetics/$'
import { Route as PrivateMeqLiveAdminScanAnalysisRouteImport } from './routes/_private/meq-live-admin/scan-analysis'
import { Route as PrivateMeqLiveAdminSplatRouteImport } from './routes/_private/meq-live-admin/$'
import { Route as PrivateMeqCameraSplatRouteImport } from './routes/_private/meq-camera/$'
import { Route as PrivateManagementSplatRouteImport } from './routes/_private/management/$'
import { Route as PrivateGmpLambDataAnalysisSplatRouteImport } from './routes/_private/gmp-lamb-data-analysis/$'
import { Route as PrivateGmpLambBookingsSplatRouteImport } from './routes/_private/gmp-lamb-bookings/$'
import { Route as PrivateDataAnalysisOverviewSplatRouteImport } from './routes/_private/data-analysis-overview/$'
import { Route as PrivateAdministrationUsersRouteImport } from './routes/_private/administration/users'
import { Route as PrivateAdministrationLocationsRouteImport } from './routes/_private/administration/locations'
import { Route as PrivateAdministrationAuditRouteImport } from './routes/_private/administration/audit'
import { Route as PrivateAdministrationActionLogRouteImport } from './routes/_private/administration/action-log'
import { Route as PrivateAdministrationAccessRouteImport } from './routes/_private/administration/access'
import { Route as PrivateAdministrationSplatRouteImport } from './routes/_private/administration/$'
import { Route as PrivateRecordLabellingAdminProjectsIndexRouteImport } from './routes/_private/record-labelling-admin/projects/index'
import { Route as PrivateRecordLabellingAdminProjectsIdIndexRouteImport } from './routes/_private/record-labelling-admin/projects/$id/index'
import { Route as PrivateRecordLabellingAdminProjectsIdEditRouteImport } from './routes/_private/record-labelling-admin/projects/$id/edit'
import { Route as PrivateRecordLabellingAdminProjectsIdBatchesBatchIdRouteImport } from './routes/_private/record-labelling-admin/projects/$id/batches/$batchId'

const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoadingRoute = LoadingRouteImport.update({
  id: '/loading',
  path: '/loading',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateRoute = PrivateRouteImport.update({
  id: '/_private',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateUsdaImageCalibrationRoute =
  PrivateUsdaImageCalibrationRouteImport.update({
    id: '/usda-image-calibration',
    path: '/usda-image-calibration',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateUsdaAuditFeedbackRoute =
  PrivateUsdaAuditFeedbackRouteImport.update({
    id: '/usda-audit-feedback',
    path: '/usda-audit-feedback',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateUsdaAuditRoute = PrivateUsdaAuditRouteImport.update({
  id: '/usda-audit',
  path: '/usda-audit',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateNoPackagesRoute = PrivateNoPackagesRouteImport.update({
  id: '/no-packages',
  path: '/no-packages',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateMeqLiveGeneticsRoute = PrivateMeqLiveGeneticsRouteImport.update({
  id: '/meq-live-genetics',
  path: '/meq-live-genetics',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateMeqLiveAdminRoute = PrivateMeqLiveAdminRouteImport.update({
  id: '/meq-live-admin',
  path: '/meq-live-admin',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateMeqLiveRoute = PrivateMeqLiveRouteImport.update({
  id: '/meq-live',
  path: '/meq-live',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateMainRoute = PrivateMainRouteImport.update({
  id: '/main',
  path: '/main',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateGmpUploadRoute = PrivateGmpUploadRouteImport.update({
  id: '/gmp-upload',
  path: '/gmp-upload',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateAdministrationRoute = PrivateAdministrationRouteImport.update({
  id: '/administration',
  path: '/administration',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateUsdaAuditIndexRoute = PrivateUsdaAuditIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateUsdaAuditRoute,
} as any)
const PrivateUsdaAuditFeedbackIndexRoute =
  PrivateUsdaAuditFeedbackIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateUsdaAuditFeedbackRoute,
  } as any)
const PrivateRecordLabellingAdminIndexRoute =
  PrivateRecordLabellingAdminIndexRouteImport.update({
    id: '/record-labelling-admin/',
    path: '/record-labelling-admin/',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateMeqProbeIndexRoute = PrivateMeqProbeIndexRouteImport.update({
  id: '/meq-probe/',
  path: '/meq-probe/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateMeqLiveIndexRoute = PrivateMeqLiveIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateMeqLiveRoute,
} as any)
const PrivateMeqLiveGeneticsIndexRoute =
  PrivateMeqLiveGeneticsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateMeqLiveGeneticsRoute,
  } as any)
const PrivateMeqLiveAdminIndexRoute =
  PrivateMeqLiveAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateMeqLiveAdminRoute,
  } as any)
const PrivateMeqCameraIndexRoute = PrivateMeqCameraIndexRouteImport.update({
  id: '/meq-camera/',
  path: '/meq-camera/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateManagementIndexRoute = PrivateManagementIndexRouteImport.update({
  id: '/management/',
  path: '/management/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateGmpLambDataAnalysisIndexRoute =
  PrivateGmpLambDataAnalysisIndexRouteImport.update({
    id: '/gmp-lamb-data-analysis/',
    path: '/gmp-lamb-data-analysis/',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateGmpLambBookingsIndexRoute =
  PrivateGmpLambBookingsIndexRouteImport.update({
    id: '/gmp-lamb-bookings/',
    path: '/gmp-lamb-bookings/',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateDataAnalysisOverviewIndexRoute =
  PrivateDataAnalysisOverviewIndexRouteImport.update({
    id: '/data-analysis-overview/',
    path: '/data-analysis-overview/',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateAdministrationIndexRoute =
  PrivateAdministrationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateAdministrationRoute,
  } as any)
const PrivateUsdaAuditResultsRoute = PrivateUsdaAuditResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => PrivateUsdaAuditRoute,
} as any)
const PrivateUsdaAuditAuditRoute = PrivateUsdaAuditAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => PrivateUsdaAuditRoute,
} as any)
const PrivateUsdaAuditSplatRoute = PrivateUsdaAuditSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => PrivateUsdaAuditRoute,
} as any)
const PrivateUsdaAuditFeedbackAuditRoute =
  PrivateUsdaAuditFeedbackAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => PrivateUsdaAuditFeedbackRoute,
  } as any)
const PrivateUsdaAuditFeedbackSplatRoute =
  PrivateUsdaAuditFeedbackSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => PrivateUsdaAuditFeedbackRoute,
  } as any)
const PrivateRecordLabellingMyAssignmentsRoute =
  PrivateRecordLabellingMyAssignmentsRouteImport.update({
    id: '/record-labelling/my-assignments',
    path: '/record-labelling/my-assignments',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateRecordLabellingAdminSetupRoute =
  PrivateRecordLabellingAdminSetupRouteImport.update({
    id: '/record-labelling-admin/setup',
    path: '/record-labelling-admin/setup',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateRecordLabellingAdminSplatRoute =
  PrivateRecordLabellingAdminSplatRouteImport.update({
    id: '/record-labelling-admin/$',
    path: '/record-labelling-admin/$',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateMeqProbeSplatRoute = PrivateMeqProbeSplatRouteImport.update({
  id: '/meq-probe/$',
  path: '/meq-probe/$',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateMeqLiveSummaryOfScansRoute =
  PrivateMeqLiveSummaryOfScansRouteImport.update({
    id: '/summary-of-scans',
    path: '/summary-of-scans',
    getParentRoute: () => PrivateMeqLiveRoute,
  } as any)
const PrivateMeqLiveSplatRoute = PrivateMeqLiveSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => PrivateMeqLiveRoute,
} as any)
const PrivateMeqLiveGeneticsSireAnalysisRoute =
  PrivateMeqLiveGeneticsSireAnalysisRouteImport.update({
    id: '/sire-analysis',
    path: '/sire-analysis',
    getParentRoute: () => PrivateMeqLiveGeneticsRoute,
  } as any)
const PrivateMeqLiveGeneticsSplatRoute =
  PrivateMeqLiveGeneticsSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => PrivateMeqLiveGeneticsRoute,
  } as any)
const PrivateMeqLiveAdminScanAnalysisRoute =
  PrivateMeqLiveAdminScanAnalysisRouteImport.update({
    id: '/scan-analysis',
    path: '/scan-analysis',
    getParentRoute: () => PrivateMeqLiveAdminRoute,
  } as any)
const PrivateMeqLiveAdminSplatRoute =
  PrivateMeqLiveAdminSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => PrivateMeqLiveAdminRoute,
  } as any)
const PrivateMeqCameraSplatRoute = PrivateMeqCameraSplatRouteImport.update({
  id: '/meq-camera/$',
  path: '/meq-camera/$',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateManagementSplatRoute = PrivateManagementSplatRouteImport.update({
  id: '/management/$',
  path: '/management/$',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateGmpLambDataAnalysisSplatRoute =
  PrivateGmpLambDataAnalysisSplatRouteImport.update({
    id: '/gmp-lamb-data-analysis/$',
    path: '/gmp-lamb-data-analysis/$',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateGmpLambBookingsSplatRoute =
  PrivateGmpLambBookingsSplatRouteImport.update({
    id: '/gmp-lamb-bookings/$',
    path: '/gmp-lamb-bookings/$',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateDataAnalysisOverviewSplatRoute =
  PrivateDataAnalysisOverviewSplatRouteImport.update({
    id: '/data-analysis-overview/$',
    path: '/data-analysis-overview/$',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateAdministrationUsersRoute =
  PrivateAdministrationUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => PrivateAdministrationRoute,
  } as any)
const PrivateAdministrationLocationsRoute =
  PrivateAdministrationLocationsRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => PrivateAdministrationRoute,
  } as any)
const PrivateAdministrationAuditRoute =
  PrivateAdministrationAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => PrivateAdministrationRoute,
  } as any)
const PrivateAdministrationActionLogRoute =
  PrivateAdministrationActionLogRouteImport.update({
    id: '/action-log',
    path: '/action-log',
    getParentRoute: () => PrivateAdministrationRoute,
  } as any)
const PrivateAdministrationAccessRoute =
  PrivateAdministrationAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => PrivateAdministrationRoute,
  } as any)
const PrivateAdministrationSplatRoute =
  PrivateAdministrationSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => PrivateAdministrationRoute,
  } as any)
const PrivateRecordLabellingAdminProjectsIndexRoute =
  PrivateRecordLabellingAdminProjectsIndexRouteImport.update({
    id: '/record-labelling-admin/projects/',
    path: '/record-labelling-admin/projects/',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateRecordLabellingAdminProjectsIdIndexRoute =
  PrivateRecordLabellingAdminProjectsIdIndexRouteImport.update({
    id: '/record-labelling-admin/projects/$id/',
    path: '/record-labelling-admin/projects/$id/',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateRecordLabellingAdminProjectsIdEditRoute =
  PrivateRecordLabellingAdminProjectsIdEditRouteImport.update({
    id: '/record-labelling-admin/projects/$id/edit',
    path: '/record-labelling-admin/projects/$id/edit',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateRecordLabellingAdminProjectsIdBatchesBatchIdRoute =
  PrivateRecordLabellingAdminProjectsIdBatchesBatchIdRouteImport.update({
    id: '/record-labelling-admin/projects/$id/batches/$batchId',
    path: '/record-labelling-admin/projects/$id/batches/$batchId',
    getParentRoute: () => PrivateRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/loading': typeof LoadingRoute
  '/logout': typeof LogoutRoute
  '/administration': typeof PrivateAdministrationRouteWithChildren
  '/gmp-upload': typeof PrivateGmpUploadRoute
  '/main': typeof PrivateMainRoute
  '/meq-live': typeof PrivateMeqLiveRouteWithChildren
  '/meq-live-admin': typeof PrivateMeqLiveAdminRouteWithChildren
  '/meq-live-genetics': typeof PrivateMeqLiveGeneticsRouteWithChildren
  '/no-packages': typeof PrivateNoPackagesRoute
  '/usda-audit': typeof PrivateUsdaAuditRouteWithChildren
  '/usda-audit-feedback': typeof PrivateUsdaAuditFeedbackRouteWithChildren
  '/usda-image-calibration': typeof PrivateUsdaImageCalibrationRoute
  '/administration/$': typeof PrivateAdministrationSplatRoute
  '/administration/access': typeof PrivateAdministrationAccessRoute
  '/administration/action-log': typeof PrivateAdministrationActionLogRoute
  '/administration/audit': typeof PrivateAdministrationAuditRoute
  '/administration/locations': typeof PrivateAdministrationLocationsRoute
  '/administration/users': typeof PrivateAdministrationUsersRoute
  '/data-analysis-overview/$': typeof PrivateDataAnalysisOverviewSplatRoute
  '/gmp-lamb-bookings/$': typeof PrivateGmpLambBookingsSplatRoute
  '/gmp-lamb-data-analysis/$': typeof PrivateGmpLambDataAnalysisSplatRoute
  '/management/$': typeof PrivateManagementSplatRoute
  '/meq-camera/$': typeof PrivateMeqCameraSplatRoute
  '/meq-live-admin/$': typeof PrivateMeqLiveAdminSplatRoute
  '/meq-live-admin/scan-analysis': typeof PrivateMeqLiveAdminScanAnalysisRoute
  '/meq-live-genetics/$': typeof PrivateMeqLiveGeneticsSplatRoute
  '/meq-live-genetics/sire-analysis': typeof PrivateMeqLiveGeneticsSireAnalysisRoute
  '/meq-live/$': typeof PrivateMeqLiveSplatRoute
  '/meq-live/summary-of-scans': typeof PrivateMeqLiveSummaryOfScansRoute
  '/meq-probe/$': typeof PrivateMeqProbeSplatRoute
  '/record-labelling-admin/$': typeof PrivateRecordLabellingAdminSplatRoute
  '/record-labelling-admin/setup': typeof PrivateRecordLabellingAdminSetupRoute
  '/record-labelling/my-assignments': typeof PrivateRecordLabellingMyAssignmentsRoute
  '/usda-audit-feedback/$': typeof PrivateUsdaAuditFeedbackSplatRoute
  '/usda-audit-feedback/audit': typeof PrivateUsdaAuditFeedbackAuditRoute
  '/usda-audit/$': typeof PrivateUsdaAuditSplatRoute
  '/usda-audit/audit': typeof PrivateUsdaAuditAuditRoute
  '/usda-audit/results': typeof PrivateUsdaAuditResultsRoute
  '/administration/': typeof PrivateAdministrationIndexRoute
  '/data-analysis-overview/': typeof PrivateDataAnalysisOverviewIndexRoute
  '/gmp-lamb-bookings/': typeof PrivateGmpLambBookingsIndexRoute
  '/gmp-lamb-data-analysis/': typeof PrivateGmpLambDataAnalysisIndexRoute
  '/management/': typeof PrivateManagementIndexRoute
  '/meq-camera/': typeof PrivateMeqCameraIndexRoute
  '/meq-live-admin/': typeof PrivateMeqLiveAdminIndexRoute
  '/meq-live-genetics/': typeof PrivateMeqLiveGeneticsIndexRoute
  '/meq-live/': typeof PrivateMeqLiveIndexRoute
  '/meq-probe/': typeof PrivateMeqProbeIndexRoute
  '/record-labelling-admin/': typeof PrivateRecordLabellingAdminIndexRoute
  '/usda-audit-feedback/': typeof PrivateUsdaAuditFeedbackIndexRoute
  '/usda-audit/': typeof PrivateUsdaAuditIndexRoute
  '/record-labelling-admin/projects/': typeof PrivateRecordLabellingAdminProjectsIndexRoute
  '/record-labelling-admin/projects/$id/edit': typeof PrivateRecordLabellingAdminProjectsIdEditRoute
  '/record-labelling-admin/projects/$id/': typeof PrivateRecordLabellingAdminProjectsIdIndexRoute
  '/record-labelling-admin/projects/$id/batches/$batchId': typeof PrivateRecordLabellingAdminProjectsIdBatchesBatchIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/loading': typeof LoadingRoute
  '/logout': typeof LogoutRoute
  '/gmp-upload': typeof PrivateGmpUploadRoute
  '/main': typeof PrivateMainRoute
  '/no-packages': typeof PrivateNoPackagesRoute
  '/usda-image-calibration': typeof PrivateUsdaImageCalibrationRoute
  '/administration/$': typeof PrivateAdministrationSplatRoute
  '/administration/access': typeof PrivateAdministrationAccessRoute
  '/administration/action-log': typeof PrivateAdministrationActionLogRoute
  '/administration/audit': typeof PrivateAdministrationAuditRoute
  '/administration/locations': typeof PrivateAdministrationLocationsRoute
  '/administration/users': typeof PrivateAdministrationUsersRoute
  '/data-analysis-overview/$': typeof PrivateDataAnalysisOverviewSplatRoute
  '/gmp-lamb-bookings/$': typeof PrivateGmpLambBookingsSplatRoute
  '/gmp-lamb-data-analysis/$': typeof PrivateGmpLambDataAnalysisSplatRoute
  '/management/$': typeof PrivateManagementSplatRoute
  '/meq-camera/$': typeof PrivateMeqCameraSplatRoute
  '/meq-live-admin/$': typeof PrivateMeqLiveAdminSplatRoute
  '/meq-live-admin/scan-analysis': typeof PrivateMeqLiveAdminScanAnalysisRoute
  '/meq-live-genetics/$': typeof PrivateMeqLiveGeneticsSplatRoute
  '/meq-live-genetics/sire-analysis': typeof PrivateMeqLiveGeneticsSireAnalysisRoute
  '/meq-live/$': typeof PrivateMeqLiveSplatRoute
  '/meq-live/summary-of-scans': typeof PrivateMeqLiveSummaryOfScansRoute
  '/meq-probe/$': typeof PrivateMeqProbeSplatRoute
  '/record-labelling-admin/$': typeof PrivateRecordLabellingAdminSplatRoute
  '/record-labelling-admin/setup': typeof PrivateRecordLabellingAdminSetupRoute
  '/record-labelling/my-assignments': typeof PrivateRecordLabellingMyAssignmentsRoute
  '/usda-audit-feedback/$': typeof PrivateUsdaAuditFeedbackSplatRoute
  '/usda-audit-feedback/audit': typeof PrivateUsdaAuditFeedbackAuditRoute
  '/usda-audit/$': typeof PrivateUsdaAuditSplatRoute
  '/usda-audit/audit': typeof PrivateUsdaAuditAuditRoute
  '/usda-audit/results': typeof PrivateUsdaAuditResultsRoute
  '/administration': typeof PrivateAdministrationIndexRoute
  '/data-analysis-overview': typeof PrivateDataAnalysisOverviewIndexRoute
  '/gmp-lamb-bookings': typeof PrivateGmpLambBookingsIndexRoute
  '/gmp-lamb-data-analysis': typeof PrivateGmpLambDataAnalysisIndexRoute
  '/management': typeof PrivateManagementIndexRoute
  '/meq-camera': typeof PrivateMeqCameraIndexRoute
  '/meq-live-admin': typeof PrivateMeqLiveAdminIndexRoute
  '/meq-live-genetics': typeof PrivateMeqLiveGeneticsIndexRoute
  '/meq-live': typeof PrivateMeqLiveIndexRoute
  '/meq-probe': typeof PrivateMeqProbeIndexRoute
  '/record-labelling-admin': typeof PrivateRecordLabellingAdminIndexRoute
  '/usda-audit-feedback': typeof PrivateUsdaAuditFeedbackIndexRoute
  '/usda-audit': typeof PrivateUsdaAuditIndexRoute
  '/record-labelling-admin/projects': typeof PrivateRecordLabellingAdminProjectsIndexRoute
  '/record-labelling-admin/projects/$id/edit': typeof PrivateRecordLabellingAdminProjectsIdEditRoute
  '/record-labelling-admin/projects/$id': typeof PrivateRecordLabellingAdminProjectsIdIndexRoute
  '/record-labelling-admin/projects/$id/batches/$batchId': typeof PrivateRecordLabellingAdminProjectsIdBatchesBatchIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_private': typeof PrivateRouteWithChildren
  '/callback': typeof CallbackRoute
  '/loading': typeof LoadingRoute
  '/logout': typeof LogoutRoute
  '/_private/administration': typeof PrivateAdministrationRouteWithChildren
  '/_private/gmp-upload': typeof PrivateGmpUploadRoute
  '/_private/main': typeof PrivateMainRoute
  '/_private/meq-live': typeof PrivateMeqLiveRouteWithChildren
  '/_private/meq-live-admin': typeof PrivateMeqLiveAdminRouteWithChildren
  '/_private/meq-live-genetics': typeof PrivateMeqLiveGeneticsRouteWithChildren
  '/_private/no-packages': typeof PrivateNoPackagesRoute
  '/_private/usda-audit': typeof PrivateUsdaAuditRouteWithChildren
  '/_private/usda-audit-feedback': typeof PrivateUsdaAuditFeedbackRouteWithChildren
  '/_private/usda-image-calibration': typeof PrivateUsdaImageCalibrationRoute
  '/_private/administration/$': typeof PrivateAdministrationSplatRoute
  '/_private/administration/access': typeof PrivateAdministrationAccessRoute
  '/_private/administration/action-log': typeof PrivateAdministrationActionLogRoute
  '/_private/administration/audit': typeof PrivateAdministrationAuditRoute
  '/_private/administration/locations': typeof PrivateAdministrationLocationsRoute
  '/_private/administration/users': typeof PrivateAdministrationUsersRoute
  '/_private/data-analysis-overview/$': typeof PrivateDataAnalysisOverviewSplatRoute
  '/_private/gmp-lamb-bookings/$': typeof PrivateGmpLambBookingsSplatRoute
  '/_private/gmp-lamb-data-analysis/$': typeof PrivateGmpLambDataAnalysisSplatRoute
  '/_private/management/$': typeof PrivateManagementSplatRoute
  '/_private/meq-camera/$': typeof PrivateMeqCameraSplatRoute
  '/_private/meq-live-admin/$': typeof PrivateMeqLiveAdminSplatRoute
  '/_private/meq-live-admin/scan-analysis': typeof PrivateMeqLiveAdminScanAnalysisRoute
  '/_private/meq-live-genetics/$': typeof PrivateMeqLiveGeneticsSplatRoute
  '/_private/meq-live-genetics/sire-analysis': typeof PrivateMeqLiveGeneticsSireAnalysisRoute
  '/_private/meq-live/$': typeof PrivateMeqLiveSplatRoute
  '/_private/meq-live/summary-of-scans': typeof PrivateMeqLiveSummaryOfScansRoute
  '/_private/meq-probe/$': typeof PrivateMeqProbeSplatRoute
  '/_private/record-labelling-admin/$': typeof PrivateRecordLabellingAdminSplatRoute
  '/_private/record-labelling-admin/setup': typeof PrivateRecordLabellingAdminSetupRoute
  '/_private/record-labelling/my-assignments': typeof PrivateRecordLabellingMyAssignmentsRoute
  '/_private/usda-audit-feedback/$': typeof PrivateUsdaAuditFeedbackSplatRoute
  '/_private/usda-audit-feedback/audit': typeof PrivateUsdaAuditFeedbackAuditRoute
  '/_private/usda-audit/$': typeof PrivateUsdaAuditSplatRoute
  '/_private/usda-audit/audit': typeof PrivateUsdaAuditAuditRoute
  '/_private/usda-audit/results': typeof PrivateUsdaAuditResultsRoute
  '/_private/administration/': typeof PrivateAdministrationIndexRoute
  '/_private/data-analysis-overview/': typeof PrivateDataAnalysisOverviewIndexRoute
  '/_private/gmp-lamb-bookings/': typeof PrivateGmpLambBookingsIndexRoute
  '/_private/gmp-lamb-data-analysis/': typeof PrivateGmpLambDataAnalysisIndexRoute
  '/_private/management/': typeof PrivateManagementIndexRoute
  '/_private/meq-camera/': typeof PrivateMeqCameraIndexRoute
  '/_private/meq-live-admin/': typeof PrivateMeqLiveAdminIndexRoute
  '/_private/meq-live-genetics/': typeof PrivateMeqLiveGeneticsIndexRoute
  '/_private/meq-live/': typeof PrivateMeqLiveIndexRoute
  '/_private/meq-probe/': typeof PrivateMeqProbeIndexRoute
  '/_private/record-labelling-admin/': typeof PrivateRecordLabellingAdminIndexRoute
  '/_private/usda-audit-feedback/': typeof PrivateUsdaAuditFeedbackIndexRoute
  '/_private/usda-audit/': typeof PrivateUsdaAuditIndexRoute
  '/_private/record-labelling-admin/projects/': typeof PrivateRecordLabellingAdminProjectsIndexRoute
  '/_private/record-labelling-admin/projects/$id/edit': typeof PrivateRecordLabellingAdminProjectsIdEditRoute
  '/_private/record-labelling-admin/projects/$id/': typeof PrivateRecordLabellingAdminProjectsIdIndexRoute
  '/_private/record-labelling-admin/projects/$id/batches/$batchId': typeof PrivateRecordLabellingAdminProjectsIdBatchesBatchIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/loading'
    | '/logout'
    | '/administration'
    | '/gmp-upload'
    | '/main'
    | '/meq-live'
    | '/meq-live-admin'
    | '/meq-live-genetics'
    | '/no-packages'
    | '/usda-audit'
    | '/usda-audit-feedback'
    | '/usda-image-calibration'
    | '/administration/$'
    | '/administration/access'
    | '/administration/action-log'
    | '/administration/audit'
    | '/administration/locations'
    | '/administration/users'
    | '/data-analysis-overview/$'
    | '/gmp-lamb-bookings/$'
    | '/gmp-lamb-data-analysis/$'
    | '/management/$'
    | '/meq-camera/$'
    | '/meq-live-admin/$'
    | '/meq-live-admin/scan-analysis'
    | '/meq-live-genetics/$'
    | '/meq-live-genetics/sire-analysis'
    | '/meq-live/$'
    | '/meq-live/summary-of-scans'
    | '/meq-probe/$'
    | '/record-labelling-admin/$'
    | '/record-labelling-admin/setup'
    | '/record-labelling/my-assignments'
    | '/usda-audit-feedback/$'
    | '/usda-audit-feedback/audit'
    | '/usda-audit/$'
    | '/usda-audit/audit'
    | '/usda-audit/results'
    | '/administration/'
    | '/data-analysis-overview/'
    | '/gmp-lamb-bookings/'
    | '/gmp-lamb-data-analysis/'
    | '/management/'
    | '/meq-camera/'
    | '/meq-live-admin/'
    | '/meq-live-genetics/'
    | '/meq-live/'
    | '/meq-probe/'
    | '/record-labelling-admin/'
    | '/usda-audit-feedback/'
    | '/usda-audit/'
    | '/record-labelling-admin/projects/'
    | '/record-labelling-admin/projects/$id/edit'
    | '/record-labelling-admin/projects/$id/'
    | '/record-labelling-admin/projects/$id/batches/$batchId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/callback'
    | '/loading'
    | '/logout'
    | '/gmp-upload'
    | '/main'
    | '/no-packages'
    | '/usda-image-calibration'
    | '/administration/$'
    | '/administration/access'
    | '/administration/action-log'
    | '/administration/audit'
    | '/administration/locations'
    | '/administration/users'
    | '/data-analysis-overview/$'
    | '/gmp-lamb-bookings/$'
    | '/gmp-lamb-data-analysis/$'
    | '/management/$'
    | '/meq-camera/$'
    | '/meq-live-admin/$'
    | '/meq-live-admin/scan-analysis'
    | '/meq-live-genetics/$'
    | '/meq-live-genetics/sire-analysis'
    | '/meq-live/$'
    | '/meq-live/summary-of-scans'
    | '/meq-probe/$'
    | '/record-labelling-admin/$'
    | '/record-labelling-admin/setup'
    | '/record-labelling/my-assignments'
    | '/usda-audit-feedback/$'
    | '/usda-audit-feedback/audit'
    | '/usda-audit/$'
    | '/usda-audit/audit'
    | '/usda-audit/results'
    | '/administration'
    | '/data-analysis-overview'
    | '/gmp-lamb-bookings'
    | '/gmp-lamb-data-analysis'
    | '/management'
    | '/meq-camera'
    | '/meq-live-admin'
    | '/meq-live-genetics'
    | '/meq-live'
    | '/meq-probe'
    | '/record-labelling-admin'
    | '/usda-audit-feedback'
    | '/usda-audit'
    | '/record-labelling-admin/projects'
    | '/record-labelling-admin/projects/$id/edit'
    | '/record-labelling-admin/projects/$id'
    | '/record-labelling-admin/projects/$id/batches/$batchId'
  id:
    | '__root__'
    | '/'
    | '/_private'
    | '/callback'
    | '/loading'
    | '/logout'
    | '/_private/administration'
    | '/_private/gmp-upload'
    | '/_private/main'
    | '/_private/meq-live'
    | '/_private/meq-live-admin'
    | '/_private/meq-live-genetics'
    | '/_private/no-packages'
    | '/_private/usda-audit'
    | '/_private/usda-audit-feedback'
    | '/_private/usda-image-calibration'
    | '/_private/administration/$'
    | '/_private/administration/access'
    | '/_private/administration/action-log'
    | '/_private/administration/audit'
    | '/_private/administration/locations'
    | '/_private/administration/users'
    | '/_private/data-analysis-overview/$'
    | '/_private/gmp-lamb-bookings/$'
    | '/_private/gmp-lamb-data-analysis/$'
    | '/_private/management/$'
    | '/_private/meq-camera/$'
    | '/_private/meq-live-admin/$'
    | '/_private/meq-live-admin/scan-analysis'
    | '/_private/meq-live-genetics/$'
    | '/_private/meq-live-genetics/sire-analysis'
    | '/_private/meq-live/$'
    | '/_private/meq-live/summary-of-scans'
    | '/_private/meq-probe/$'
    | '/_private/record-labelling-admin/$'
    | '/_private/record-labelling-admin/setup'
    | '/_private/record-labelling/my-assignments'
    | '/_private/usda-audit-feedback/$'
    | '/_private/usda-audit-feedback/audit'
    | '/_private/usda-audit/$'
    | '/_private/usda-audit/audit'
    | '/_private/usda-audit/results'
    | '/_private/administration/'
    | '/_private/data-analysis-overview/'
    | '/_private/gmp-lamb-bookings/'
    | '/_private/gmp-lamb-data-analysis/'
    | '/_private/management/'
    | '/_private/meq-camera/'
    | '/_private/meq-live-admin/'
    | '/_private/meq-live-genetics/'
    | '/_private/meq-live/'
    | '/_private/meq-probe/'
    | '/_private/record-labelling-admin/'
    | '/_private/usda-audit-feedback/'
    | '/_private/usda-audit/'
    | '/_private/record-labelling-admin/projects/'
    | '/_private/record-labelling-admin/projects/$id/edit'
    | '/_private/record-labelling-admin/projects/$id/'
    | '/_private/record-labelling-admin/projects/$id/batches/$batchId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PrivateRoute: typeof PrivateRouteWithChildren
  CallbackRoute: typeof CallbackRoute
  LoadingRoute: typeof LoadingRoute
  LogoutRoute: typeof LogoutRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loading': {
      id: '/loading'
      path: '/loading'
      fullPath: '/loading'
      preLoaderRoute: typeof LoadingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PrivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private/usda-image-calibration': {
      id: '/_private/usda-image-calibration'
      path: '/usda-image-calibration'
      fullPath: '/usda-image-calibration'
      preLoaderRoute: typeof PrivateUsdaImageCalibrationRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/usda-audit-feedback': {
      id: '/_private/usda-audit-feedback'
      path: '/usda-audit-feedback'
      fullPath: '/usda-audit-feedback'
      preLoaderRoute: typeof PrivateUsdaAuditFeedbackRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/usda-audit': {
      id: '/_private/usda-audit'
      path: '/usda-audit'
      fullPath: '/usda-audit'
      preLoaderRoute: typeof PrivateUsdaAuditRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/no-packages': {
      id: '/_private/no-packages'
      path: '/no-packages'
      fullPath: '/no-packages'
      preLoaderRoute: typeof PrivateNoPackagesRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/meq-live-genetics': {
      id: '/_private/meq-live-genetics'
      path: '/meq-live-genetics'
      fullPath: '/meq-live-genetics'
      preLoaderRoute: typeof PrivateMeqLiveGeneticsRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/meq-live-admin': {
      id: '/_private/meq-live-admin'
      path: '/meq-live-admin'
      fullPath: '/meq-live-admin'
      preLoaderRoute: typeof PrivateMeqLiveAdminRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/meq-live': {
      id: '/_private/meq-live'
      path: '/meq-live'
      fullPath: '/meq-live'
      preLoaderRoute: typeof PrivateMeqLiveRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/main': {
      id: '/_private/main'
      path: '/main'
      fullPath: '/main'
      preLoaderRoute: typeof PrivateMainRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/gmp-upload': {
      id: '/_private/gmp-upload'
      path: '/gmp-upload'
      fullPath: '/gmp-upload'
      preLoaderRoute: typeof PrivateGmpUploadRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/administration': {
      id: '/_private/administration'
      path: '/administration'
      fullPath: '/administration'
      preLoaderRoute: typeof PrivateAdministrationRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/usda-audit/': {
      id: '/_private/usda-audit/'
      path: '/'
      fullPath: '/usda-audit/'
      preLoaderRoute: typeof PrivateUsdaAuditIndexRouteImport
      parentRoute: typeof PrivateUsdaAuditRoute
    }
    '/_private/usda-audit-feedback/': {
      id: '/_private/usda-audit-feedback/'
      path: '/'
      fullPath: '/usda-audit-feedback/'
      preLoaderRoute: typeof PrivateUsdaAuditFeedbackIndexRouteImport
      parentRoute: typeof PrivateUsdaAuditFeedbackRoute
    }
    '/_private/record-labelling-admin/': {
      id: '/_private/record-labelling-admin/'
      path: '/record-labelling-admin'
      fullPath: '/record-labelling-admin/'
      preLoaderRoute: typeof PrivateRecordLabellingAdminIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/meq-probe/': {
      id: '/_private/meq-probe/'
      path: '/meq-probe'
      fullPath: '/meq-probe/'
      preLoaderRoute: typeof PrivateMeqProbeIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/meq-live/': {
      id: '/_private/meq-live/'
      path: '/'
      fullPath: '/meq-live/'
      preLoaderRoute: typeof PrivateMeqLiveIndexRouteImport
      parentRoute: typeof PrivateMeqLiveRoute
    }
    '/_private/meq-live-genetics/': {
      id: '/_private/meq-live-genetics/'
      path: '/'
      fullPath: '/meq-live-genetics/'
      preLoaderRoute: typeof PrivateMeqLiveGeneticsIndexRouteImport
      parentRoute: typeof PrivateMeqLiveGeneticsRoute
    }
    '/_private/meq-live-admin/': {
      id: '/_private/meq-live-admin/'
      path: '/'
      fullPath: '/meq-live-admin/'
      preLoaderRoute: typeof PrivateMeqLiveAdminIndexRouteImport
      parentRoute: typeof PrivateMeqLiveAdminRoute
    }
    '/_private/meq-camera/': {
      id: '/_private/meq-camera/'
      path: '/meq-camera'
      fullPath: '/meq-camera/'
      preLoaderRoute: typeof PrivateMeqCameraIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/management/': {
      id: '/_private/management/'
      path: '/management'
      fullPath: '/management/'
      preLoaderRoute: typeof PrivateManagementIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/gmp-lamb-data-analysis/': {
      id: '/_private/gmp-lamb-data-analysis/'
      path: '/gmp-lamb-data-analysis'
      fullPath: '/gmp-lamb-data-analysis/'
      preLoaderRoute: typeof PrivateGmpLambDataAnalysisIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/gmp-lamb-bookings/': {
      id: '/_private/gmp-lamb-bookings/'
      path: '/gmp-lamb-bookings'
      fullPath: '/gmp-lamb-bookings/'
      preLoaderRoute: typeof PrivateGmpLambBookingsIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/data-analysis-overview/': {
      id: '/_private/data-analysis-overview/'
      path: '/data-analysis-overview'
      fullPath: '/data-analysis-overview/'
      preLoaderRoute: typeof PrivateDataAnalysisOverviewIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/administration/': {
      id: '/_private/administration/'
      path: '/'
      fullPath: '/administration/'
      preLoaderRoute: typeof PrivateAdministrationIndexRouteImport
      parentRoute: typeof PrivateAdministrationRoute
    }
    '/_private/usda-audit/results': {
      id: '/_private/usda-audit/results'
      path: '/results'
      fullPath: '/usda-audit/results'
      preLoaderRoute: typeof PrivateUsdaAuditResultsRouteImport
      parentRoute: typeof PrivateUsdaAuditRoute
    }
    '/_private/usda-audit/audit': {
      id: '/_private/usda-audit/audit'
      path: '/audit'
      fullPath: '/usda-audit/audit'
      preLoaderRoute: typeof PrivateUsdaAuditAuditRouteImport
      parentRoute: typeof PrivateUsdaAuditRoute
    }
    '/_private/usda-audit/$': {
      id: '/_private/usda-audit/$'
      path: '/$'
      fullPath: '/usda-audit/$'
      preLoaderRoute: typeof PrivateUsdaAuditSplatRouteImport
      parentRoute: typeof PrivateUsdaAuditRoute
    }
    '/_private/usda-audit-feedback/audit': {
      id: '/_private/usda-audit-feedback/audit'
      path: '/audit'
      fullPath: '/usda-audit-feedback/audit'
      preLoaderRoute: typeof PrivateUsdaAuditFeedbackAuditRouteImport
      parentRoute: typeof PrivateUsdaAuditFeedbackRoute
    }
    '/_private/usda-audit-feedback/$': {
      id: '/_private/usda-audit-feedback/$'
      path: '/$'
      fullPath: '/usda-audit-feedback/$'
      preLoaderRoute: typeof PrivateUsdaAuditFeedbackSplatRouteImport
      parentRoute: typeof PrivateUsdaAuditFeedbackRoute
    }
    '/_private/record-labelling/my-assignments': {
      id: '/_private/record-labelling/my-assignments'
      path: '/record-labelling/my-assignments'
      fullPath: '/record-labelling/my-assignments'
      preLoaderRoute: typeof PrivateRecordLabellingMyAssignmentsRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/record-labelling-admin/setup': {
      id: '/_private/record-labelling-admin/setup'
      path: '/record-labelling-admin/setup'
      fullPath: '/record-labelling-admin/setup'
      preLoaderRoute: typeof PrivateRecordLabellingAdminSetupRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/record-labelling-admin/$': {
      id: '/_private/record-labelling-admin/$'
      path: '/record-labelling-admin/$'
      fullPath: '/record-labelling-admin/$'
      preLoaderRoute: typeof PrivateRecordLabellingAdminSplatRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/meq-probe/$': {
      id: '/_private/meq-probe/$'
      path: '/meq-probe/$'
      fullPath: '/meq-probe/$'
      preLoaderRoute: typeof PrivateMeqProbeSplatRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/meq-live/summary-of-scans': {
      id: '/_private/meq-live/summary-of-scans'
      path: '/summary-of-scans'
      fullPath: '/meq-live/summary-of-scans'
      preLoaderRoute: typeof PrivateMeqLiveSummaryOfScansRouteImport
      parentRoute: typeof PrivateMeqLiveRoute
    }
    '/_private/meq-live/$': {
      id: '/_private/meq-live/$'
      path: '/$'
      fullPath: '/meq-live/$'
      preLoaderRoute: typeof PrivateMeqLiveSplatRouteImport
      parentRoute: typeof PrivateMeqLiveRoute
    }
    '/_private/meq-live-genetics/sire-analysis': {
      id: '/_private/meq-live-genetics/sire-analysis'
      path: '/sire-analysis'
      fullPath: '/meq-live-genetics/sire-analysis'
      preLoaderRoute: typeof PrivateMeqLiveGeneticsSireAnalysisRouteImport
      parentRoute: typeof PrivateMeqLiveGeneticsRoute
    }
    '/_private/meq-live-genetics/$': {
      id: '/_private/meq-live-genetics/$'
      path: '/$'
      fullPath: '/meq-live-genetics/$'
      preLoaderRoute: typeof PrivateMeqLiveGeneticsSplatRouteImport
      parentRoute: typeof PrivateMeqLiveGeneticsRoute
    }
    '/_private/meq-live-admin/scan-analysis': {
      id: '/_private/meq-live-admin/scan-analysis'
      path: '/scan-analysis'
      fullPath: '/meq-live-admin/scan-analysis'
      preLoaderRoute: typeof PrivateMeqLiveAdminScanAnalysisRouteImport
      parentRoute: typeof PrivateMeqLiveAdminRoute
    }
    '/_private/meq-live-admin/$': {
      id: '/_private/meq-live-admin/$'
      path: '/$'
      fullPath: '/meq-live-admin/$'
      preLoaderRoute: typeof PrivateMeqLiveAdminSplatRouteImport
      parentRoute: typeof PrivateMeqLiveAdminRoute
    }
    '/_private/meq-camera/$': {
      id: '/_private/meq-camera/$'
      path: '/meq-camera/$'
      fullPath: '/meq-camera/$'
      preLoaderRoute: typeof PrivateMeqCameraSplatRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/management/$': {
      id: '/_private/management/$'
      path: '/management/$'
      fullPath: '/management/$'
      preLoaderRoute: typeof PrivateManagementSplatRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/gmp-lamb-data-analysis/$': {
      id: '/_private/gmp-lamb-data-analysis/$'
      path: '/gmp-lamb-data-analysis/$'
      fullPath: '/gmp-lamb-data-analysis/$'
      preLoaderRoute: typeof PrivateGmpLambDataAnalysisSplatRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/gmp-lamb-bookings/$': {
      id: '/_private/gmp-lamb-bookings/$'
      path: '/gmp-lamb-bookings/$'
      fullPath: '/gmp-lamb-bookings/$'
      preLoaderRoute: typeof PrivateGmpLambBookingsSplatRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/data-analysis-overview/$': {
      id: '/_private/data-analysis-overview/$'
      path: '/data-analysis-overview/$'
      fullPath: '/data-analysis-overview/$'
      preLoaderRoute: typeof PrivateDataAnalysisOverviewSplatRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/administration/users': {
      id: '/_private/administration/users'
      path: '/users'
      fullPath: '/administration/users'
      preLoaderRoute: typeof PrivateAdministrationUsersRouteImport
      parentRoute: typeof PrivateAdministrationRoute
    }
    '/_private/administration/locations': {
      id: '/_private/administration/locations'
      path: '/locations'
      fullPath: '/administration/locations'
      preLoaderRoute: typeof PrivateAdministrationLocationsRouteImport
      parentRoute: typeof PrivateAdministrationRoute
    }
    '/_private/administration/audit': {
      id: '/_private/administration/audit'
      path: '/audit'
      fullPath: '/administration/audit'
      preLoaderRoute: typeof PrivateAdministrationAuditRouteImport
      parentRoute: typeof PrivateAdministrationRoute
    }
    '/_private/administration/action-log': {
      id: '/_private/administration/action-log'
      path: '/action-log'
      fullPath: '/administration/action-log'
      preLoaderRoute: typeof PrivateAdministrationActionLogRouteImport
      parentRoute: typeof PrivateAdministrationRoute
    }
    '/_private/administration/access': {
      id: '/_private/administration/access'
      path: '/access'
      fullPath: '/administration/access'
      preLoaderRoute: typeof PrivateAdministrationAccessRouteImport
      parentRoute: typeof PrivateAdministrationRoute
    }
    '/_private/administration/$': {
      id: '/_private/administration/$'
      path: '/$'
      fullPath: '/administration/$'
      preLoaderRoute: typeof PrivateAdministrationSplatRouteImport
      parentRoute: typeof PrivateAdministrationRoute
    }
    '/_private/record-labelling-admin/projects/': {
      id: '/_private/record-labelling-admin/projects/'
      path: '/record-labelling-admin/projects'
      fullPath: '/record-labelling-admin/projects/'
      preLoaderRoute: typeof PrivateRecordLabellingAdminProjectsIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/record-labelling-admin/projects/$id/': {
      id: '/_private/record-labelling-admin/projects/$id/'
      path: '/record-labelling-admin/projects/$id'
      fullPath: '/record-labelling-admin/projects/$id/'
      preLoaderRoute: typeof PrivateRecordLabellingAdminProjectsIdIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/record-labelling-admin/projects/$id/edit': {
      id: '/_private/record-labelling-admin/projects/$id/edit'
      path: '/record-labelling-admin/projects/$id/edit'
      fullPath: '/record-labelling-admin/projects/$id/edit'
      preLoaderRoute: typeof PrivateRecordLabellingAdminProjectsIdEditRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/record-labelling-admin/projects/$id/batches/$batchId': {
      id: '/_private/record-labelling-admin/projects/$id/batches/$batchId'
      path: '/record-labelling-admin/projects/$id/batches/$batchId'
      fullPath: '/record-labelling-admin/projects/$id/batches/$batchId'
      preLoaderRoute: typeof PrivateRecordLabellingAdminProjectsIdBatchesBatchIdRouteImport
      parentRoute: typeof PrivateRoute
    }
  }
}

interface PrivateAdministrationRouteChildren {
  PrivateAdministrationSplatRoute: typeof PrivateAdministrationSplatRoute
  PrivateAdministrationAccessRoute: typeof PrivateAdministrationAccessRoute
  PrivateAdministrationActionLogRoute: typeof PrivateAdministrationActionLogRoute
  PrivateAdministrationAuditRoute: typeof PrivateAdministrationAuditRoute
  PrivateAdministrationLocationsRoute: typeof PrivateAdministrationLocationsRoute
  PrivateAdministrationUsersRoute: typeof PrivateAdministrationUsersRoute
  PrivateAdministrationIndexRoute: typeof PrivateAdministrationIndexRoute
}

const PrivateAdministrationRouteChildren: PrivateAdministrationRouteChildren = {
  PrivateAdministrationSplatRoute: PrivateAdministrationSplatRoute,
  PrivateAdministrationAccessRoute: PrivateAdministrationAccessRoute,
  PrivateAdministrationActionLogRoute: PrivateAdministrationActionLogRoute,
  PrivateAdministrationAuditRoute: PrivateAdministrationAuditRoute,
  PrivateAdministrationLocationsRoute: PrivateAdministrationLocationsRoute,
  PrivateAdministrationUsersRoute: PrivateAdministrationUsersRoute,
  PrivateAdministrationIndexRoute: PrivateAdministrationIndexRoute,
}

const PrivateAdministrationRouteWithChildren =
  PrivateAdministrationRoute._addFileChildren(
    PrivateAdministrationRouteChildren,
  )

interface PrivateMeqLiveRouteChildren {
  PrivateMeqLiveSplatRoute: typeof PrivateMeqLiveSplatRoute
  PrivateMeqLiveSummaryOfScansRoute: typeof PrivateMeqLiveSummaryOfScansRoute
  PrivateMeqLiveIndexRoute: typeof PrivateMeqLiveIndexRoute
}

const PrivateMeqLiveRouteChildren: PrivateMeqLiveRouteChildren = {
  PrivateMeqLiveSplatRoute: PrivateMeqLiveSplatRoute,
  PrivateMeqLiveSummaryOfScansRoute: PrivateMeqLiveSummaryOfScansRoute,
  PrivateMeqLiveIndexRoute: PrivateMeqLiveIndexRoute,
}

const PrivateMeqLiveRouteWithChildren = PrivateMeqLiveRoute._addFileChildren(
  PrivateMeqLiveRouteChildren,
)

interface PrivateMeqLiveAdminRouteChildren {
  PrivateMeqLiveAdminSplatRoute: typeof PrivateMeqLiveAdminSplatRoute
  PrivateMeqLiveAdminScanAnalysisRoute: typeof PrivateMeqLiveAdminScanAnalysisRoute
  PrivateMeqLiveAdminIndexRoute: typeof PrivateMeqLiveAdminIndexRoute
}

const PrivateMeqLiveAdminRouteChildren: PrivateMeqLiveAdminRouteChildren = {
  PrivateMeqLiveAdminSplatRoute: PrivateMeqLiveAdminSplatRoute,
  PrivateMeqLiveAdminScanAnalysisRoute: PrivateMeqLiveAdminScanAnalysisRoute,
  PrivateMeqLiveAdminIndexRoute: PrivateMeqLiveAdminIndexRoute,
}

const PrivateMeqLiveAdminRouteWithChildren =
  PrivateMeqLiveAdminRoute._addFileChildren(PrivateMeqLiveAdminRouteChildren)

interface PrivateMeqLiveGeneticsRouteChildren {
  PrivateMeqLiveGeneticsSplatRoute: typeof PrivateMeqLiveGeneticsSplatRoute
  PrivateMeqLiveGeneticsSireAnalysisRoute: typeof PrivateMeqLiveGeneticsSireAnalysisRoute
  PrivateMeqLiveGeneticsIndexRoute: typeof PrivateMeqLiveGeneticsIndexRoute
}

const PrivateMeqLiveGeneticsRouteChildren: PrivateMeqLiveGeneticsRouteChildren =
  {
    PrivateMeqLiveGeneticsSplatRoute: PrivateMeqLiveGeneticsSplatRoute,
    PrivateMeqLiveGeneticsSireAnalysisRoute:
      PrivateMeqLiveGeneticsSireAnalysisRoute,
    PrivateMeqLiveGeneticsIndexRoute: PrivateMeqLiveGeneticsIndexRoute,
  }

const PrivateMeqLiveGeneticsRouteWithChildren =
  PrivateMeqLiveGeneticsRoute._addFileChildren(
    PrivateMeqLiveGeneticsRouteChildren,
  )

interface PrivateUsdaAuditRouteChildren {
  PrivateUsdaAuditSplatRoute: typeof PrivateUsdaAuditSplatRoute
  PrivateUsdaAuditAuditRoute: typeof PrivateUsdaAuditAuditRoute
  PrivateUsdaAuditResultsRoute: typeof PrivateUsdaAuditResultsRoute
  PrivateUsdaAuditIndexRoute: typeof PrivateUsdaAuditIndexRoute
}

const PrivateUsdaAuditRouteChildren: PrivateUsdaAuditRouteChildren = {
  PrivateUsdaAuditSplatRoute: PrivateUsdaAuditSplatRoute,
  PrivateUsdaAuditAuditRoute: PrivateUsdaAuditAuditRoute,
  PrivateUsdaAuditResultsRoute: PrivateUsdaAuditResultsRoute,
  PrivateUsdaAuditIndexRoute: PrivateUsdaAuditIndexRoute,
}

const PrivateUsdaAuditRouteWithChildren =
  PrivateUsdaAuditRoute._addFileChildren(PrivateUsdaAuditRouteChildren)

interface PrivateUsdaAuditFeedbackRouteChildren {
  PrivateUsdaAuditFeedbackSplatRoute: typeof PrivateUsdaAuditFeedbackSplatRoute
  PrivateUsdaAuditFeedbackAuditRoute: typeof PrivateUsdaAuditFeedbackAuditRoute
  PrivateUsdaAuditFeedbackIndexRoute: typeof PrivateUsdaAuditFeedbackIndexRoute
}

const PrivateUsdaAuditFeedbackRouteChildren: PrivateUsdaAuditFeedbackRouteChildren =
  {
    PrivateUsdaAuditFeedbackSplatRoute: PrivateUsdaAuditFeedbackSplatRoute,
    PrivateUsdaAuditFeedbackAuditRoute: PrivateUsdaAuditFeedbackAuditRoute,
    PrivateUsdaAuditFeedbackIndexRoute: PrivateUsdaAuditFeedbackIndexRoute,
  }

const PrivateUsdaAuditFeedbackRouteWithChildren =
  PrivateUsdaAuditFeedbackRoute._addFileChildren(
    PrivateUsdaAuditFeedbackRouteChildren,
  )

interface PrivateRouteChildren {
  PrivateAdministrationRoute: typeof PrivateAdministrationRouteWithChildren
  PrivateGmpUploadRoute: typeof PrivateGmpUploadRoute
  PrivateMainRoute: typeof PrivateMainRoute
  PrivateMeqLiveRoute: typeof PrivateMeqLiveRouteWithChildren
  PrivateMeqLiveAdminRoute: typeof PrivateMeqLiveAdminRouteWithChildren
  PrivateMeqLiveGeneticsRoute: typeof PrivateMeqLiveGeneticsRouteWithChildren
  PrivateNoPackagesRoute: typeof PrivateNoPackagesRoute
  PrivateUsdaAuditRoute: typeof PrivateUsdaAuditRouteWithChildren
  PrivateUsdaAuditFeedbackRoute: typeof PrivateUsdaAuditFeedbackRouteWithChildren
  PrivateUsdaImageCalibrationRoute: typeof PrivateUsdaImageCalibrationRoute
  PrivateDataAnalysisOverviewSplatRoute: typeof PrivateDataAnalysisOverviewSplatRoute
  PrivateGmpLambBookingsSplatRoute: typeof PrivateGmpLambBookingsSplatRoute
  PrivateGmpLambDataAnalysisSplatRoute: typeof PrivateGmpLambDataAnalysisSplatRoute
  PrivateManagementSplatRoute: typeof PrivateManagementSplatRoute
  PrivateMeqCameraSplatRoute: typeof PrivateMeqCameraSplatRoute
  PrivateMeqProbeSplatRoute: typeof PrivateMeqProbeSplatRoute
  PrivateRecordLabellingAdminSplatRoute: typeof PrivateRecordLabellingAdminSplatRoute
  PrivateRecordLabellingAdminSetupRoute: typeof PrivateRecordLabellingAdminSetupRoute
  PrivateRecordLabellingMyAssignmentsRoute: typeof PrivateRecordLabellingMyAssignmentsRoute
  PrivateDataAnalysisOverviewIndexRoute: typeof PrivateDataAnalysisOverviewIndexRoute
  PrivateGmpLambBookingsIndexRoute: typeof PrivateGmpLambBookingsIndexRoute
  PrivateGmpLambDataAnalysisIndexRoute: typeof PrivateGmpLambDataAnalysisIndexRoute
  PrivateManagementIndexRoute: typeof PrivateManagementIndexRoute
  PrivateMeqCameraIndexRoute: typeof PrivateMeqCameraIndexRoute
  PrivateMeqProbeIndexRoute: typeof PrivateMeqProbeIndexRoute
  PrivateRecordLabellingAdminIndexRoute: typeof PrivateRecordLabellingAdminIndexRoute
  PrivateRecordLabellingAdminProjectsIndexRoute: typeof PrivateRecordLabellingAdminProjectsIndexRoute
  PrivateRecordLabellingAdminProjectsIdEditRoute: typeof PrivateRecordLabellingAdminProjectsIdEditRoute
  PrivateRecordLabellingAdminProjectsIdIndexRoute: typeof PrivateRecordLabellingAdminProjectsIdIndexRoute
  PrivateRecordLabellingAdminProjectsIdBatchesBatchIdRoute: typeof PrivateRecordLabellingAdminProjectsIdBatchesBatchIdRoute
}

const PrivateRouteChildren: PrivateRouteChildren = {
  PrivateAdministrationRoute: PrivateAdministrationRouteWithChildren,
  PrivateGmpUploadRoute: PrivateGmpUploadRoute,
  PrivateMainRoute: PrivateMainRoute,
  PrivateMeqLiveRoute: PrivateMeqLiveRouteWithChildren,
  PrivateMeqLiveAdminRoute: PrivateMeqLiveAdminRouteWithChildren,
  PrivateMeqLiveGeneticsRoute: PrivateMeqLiveGeneticsRouteWithChildren,
  PrivateNoPackagesRoute: PrivateNoPackagesRoute,
  PrivateUsdaAuditRoute: PrivateUsdaAuditRouteWithChildren,
  PrivateUsdaAuditFeedbackRoute: PrivateUsdaAuditFeedbackRouteWithChildren,
  PrivateUsdaImageCalibrationRoute: PrivateUsdaImageCalibrationRoute,
  PrivateDataAnalysisOverviewSplatRoute: PrivateDataAnalysisOverviewSplatRoute,
  PrivateGmpLambBookingsSplatRoute: PrivateGmpLambBookingsSplatRoute,
  PrivateGmpLambDataAnalysisSplatRoute: PrivateGmpLambDataAnalysisSplatRoute,
  PrivateManagementSplatRoute: PrivateManagementSplatRoute,
  PrivateMeqCameraSplatRoute: PrivateMeqCameraSplatRoute,
  PrivateMeqProbeSplatRoute: PrivateMeqProbeSplatRoute,
  PrivateRecordLabellingAdminSplatRoute: PrivateRecordLabellingAdminSplatRoute,
  PrivateRecordLabellingAdminSetupRoute: PrivateRecordLabellingAdminSetupRoute,
  PrivateRecordLabellingMyAssignmentsRoute:
    PrivateRecordLabellingMyAssignmentsRoute,
  PrivateDataAnalysisOverviewIndexRoute: PrivateDataAnalysisOverviewIndexRoute,
  PrivateGmpLambBookingsIndexRoute: PrivateGmpLambBookingsIndexRoute,
  PrivateGmpLambDataAnalysisIndexRoute: PrivateGmpLambDataAnalysisIndexRoute,
  PrivateManagementIndexRoute: PrivateManagementIndexRoute,
  PrivateMeqCameraIndexRoute: PrivateMeqCameraIndexRoute,
  PrivateMeqProbeIndexRoute: PrivateMeqProbeIndexRoute,
  PrivateRecordLabellingAdminIndexRoute: PrivateRecordLabellingAdminIndexRoute,
  PrivateRecordLabellingAdminProjectsIndexRoute:
    PrivateRecordLabellingAdminProjectsIndexRoute,
  PrivateRecordLabellingAdminProjectsIdEditRoute:
    PrivateRecordLabellingAdminProjectsIdEditRoute,
  PrivateRecordLabellingAdminProjectsIdIndexRoute:
    PrivateRecordLabellingAdminProjectsIdIndexRoute,
  PrivateRecordLabellingAdminProjectsIdBatchesBatchIdRoute:
    PrivateRecordLabellingAdminProjectsIdBatchesBatchIdRoute,
}

const PrivateRouteWithChildren =
  PrivateRoute._addFileChildren(PrivateRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PrivateRoute: PrivateRouteWithChildren,
  CallbackRoute: CallbackRoute,
  LoadingRoute: LoadingRoute,
  LogoutRoute: LogoutRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
